$(document).ready(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }

  $(".tcustomizer-checkbox__label").addClass("form-label--checkbox");
  window.addEventListener("message", function (event) {
    // Verify the origin of the sender
    if (event.origin === "https://formbuilder.hulkapps.com") {
      // Handle the message from the iframe
      if (event.data === "add-class-col") {
        // Add a class to your div
        const container = document.getElementById("backfinish-sidenav");
        container.classList.add("active");
      } else if (event.data === "add-class") {
        // Add a class to your div
        const container = document.getElementById("backingcute-sidenav");
        container.classList.add("active");
      }
    }
  });
});

const checkbox = document.getElementById("extension2");
const label = document.getElementById("rgbw-select");
const image = document.getElementById("rgbw-image-id");

/* legacy creator RGBW helper: only wire it up where that markup exists.
   Unguarded it threw "Cannot read properties of null" on every page that is
   not the old creator, because #extension2 only exists there. */
if (checkbox && label && image) {
  checkbox.addEventListener("change", function() {
    if (checkbox.checked) {
        label.classList.add("active");
        image.style.display = "block";
    } else {
        label.classList.remove("active");
      image.style.display = "none";
    }
  });
}

/* ==========================================================================
   The Afterpay instalment follows the cart total.               21 Sep 2026
   --------------------------------------------------------------------------
   The cart renders <square-placement data-amount="..."> once, server side,
   from the cart total as the page was loaded. Changing a quantity updates the
   totals over AJAX and leaves that attribute behind, so the instalment keeps
   describing the cart as it used to be: measured on 21 Sep, a cart taken from
   $857 to $1,714 still offered "4 payments of $214.25" - the figure for $857.
   That is what showed "4 payments of $149" against a $257 checkout.

   The live theme does this too: sections/main-cart.liquid is byte-identical in
   both themes (d8601f4a...), so this file is the only thing that changes.

   /cart.js is the only authority for the total. Nothing here touches price,
   the cart, or the checkout - it writes one attribute, and if the component
   has not re-rendered a moment later it remounts it so it reads the new one.
   ========================================================================== */
(function () {
  var PLACEMENT = 'square-placement[data-page-type="cart"]';
  var busy = false, timer = null;

  function rendered(el) {
    try { return (el.shadowRoot ? el.shadowRoot.textContent : el.textContent) || ''; } catch (e) { return ''; }
  }
  function apply(el, amount) {
    if (el.getAttribute('data-amount') === amount) return;
    var before = rendered(el);
    el.setAttribute('data-amount', amount);
    setTimeout(function () {
      if (!el.isConnected || rendered(el) !== before) return;   // it picked the change up by itself
      var fresh = el.cloneNode(false);
      fresh.setAttribute('data-amount', amount);
      fresh.id = 'placement-' + Date.now();
      if (el.parentNode) el.parentNode.replaceChild(fresh, el); // make it mount again
    }, 400);
  }
  function sync() {
    if (busy || !document.querySelector(PLACEMENT)) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || typeof c.total_price !== 'number') return;
        var amount = String(Math.round(c.total_price) / 100);
        Array.prototype.forEach.call(document.querySelectorAll(PLACEMENT), function (el) { apply(el, amount); });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 250); }

  function start() {
    var scope = document.querySelector('cart-items') || document.body;
    new MutationObserver(schedule).observe(scope, { childList: true, subtree: true, characterData: true });
    window.addEventListener('pageshow', schedule);
    schedule();
  }
  /* The placement does not exist when this file runs: the Afterpay snippet in
     layout/theme.liquid loads its script from static.afterpay.com and that
     script creates <square-placement> a moment later. So look for it for a
     short while and start only when it is really there. On every page that has
     no cart placement this costs thirty querySelector calls and then stops. */
  function waitForPlacement(tries) {
    if (document.querySelector(PLACEMENT)) { start(); return; }
    if (tries <= 0) return;
    setTimeout(function () { waitForPlacement(tries - 1); }, 400);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { waitForPlacement(30); });
  else waitForPlacement(30);
})();

/* ==========================================================================
   The page holds still while the size is being dragged.        21 Sep 2026
   --------------------------------------------------------------------------
   Changing the width changes how much the creator has to say: past about
   110 cm a sectioning note appears and the totals block grows a line, which
   on a 390 px phone adds ~220 px ABOVE the slider mid-drag. The browser then
   corrects the scroll position to compensate - measured at 176 px in one step
   of one drag - so the control moves under the finger while it is being held.
   That is what "the preview goes crazy" looks like from the user's side: the
   page lurches, the thumb loses the slider, and the value jumps.

   So: from the moment a drag actually changes the value until the finger comes
   off, the scroll position is held where it started. A vertical swipe that
   starts on the slider never changes the value, so it never locks and the page
   still scrolls normally (touch-action: pan-y in tnf-mobile-1-0-0.css keeps the
   browser from stealing the horizontal drag in the first place).
   Nothing here touches price, size limits, or what is sent to the cart.
   ========================================================================== */
(function () {
  var RANGE = '#tnf-creator input[type="range"]';
  var armed = false, locked = false, lockY = 0;

  function isRange(t) { return t && t.closest && t.closest(RANGE); }
  function down(e) { if (!isRange(e.target)) return; armed = true; locked = false; lockY = window.pageYOffset; }
  function changed(e) { if (armed && isRange(e.target)) locked = true; }
  function up() { armed = false; locked = false; }
  function scrolled() { if (locked && Math.abs(window.pageYOffset - lockY) > 1) window.scrollTo(0, lockY); }

  document.addEventListener('touchstart', down, { passive: true });
  document.addEventListener('pointerdown', down, { passive: true });
  document.addEventListener('mousedown', down, { passive: true });
  document.addEventListener('input', changed, true);
  /* every way a drag can end, including the ones that are not a clean release:
     the browser taking the gesture over (touchcancel / pointercancel), the
     finger or mouse coming up anywhere, the tab going away mid-drag. If the
     hold were ever left on, the page would refuse to scroll. */
  ['touchend', 'touchcancel', 'pointerup', 'pointercancel', 'mouseup', 'mouseleave', 'dragend'].forEach(function (e) {
    document.addEventListener(e, up, { passive: true });
  });
  window.addEventListener('blur', up);
  document.addEventListener('visibilitychange', up);
  window.addEventListener('scroll', scrolled, { passive: true });
})();



/* ==========================================================================
   THE CHAT BUBBLE AND THE CREATOR'S CONTROLS            21 Sep 2026
   Shopify Chat's "Need help?" bubble is fixed at bottom: 120px, right: 20px -
   on a 390 px phone, x 241-370, y 678-724. At the top of the creator page the
   "Upload your logo or image" button sits at x 273-365, y 701-755, so the
   bubble covers its top 43 %: measured, and a tap in that corner opens the
   chat instead of the picture chooser. (The same measurement on the live
   theme, so this is not something the mobile fixes introduced.)

   A fixed nudge does not fix it. The creator's picture panel starts in the
   page flow and pins itself to the top as you scroll, so the button travels
   from y 755 up to y 339 - it sweeps a 416 px band, and a 46 px bubble
   parked anywhere inside that band collides at SOME scroll position. Moving
   the bubble up 40 px was tried and measured: the overlap went from 43 % to
   79 %, just at a different scroll offset. Sideways is no better - the whole
   bottom row of the panel is controls.

   So the bubble steps aside instead of moving house. While it would overlap
   one of the creator's controls it is faded out and stops taking taps; the
   moment it would not, it is back, in its usual place, unchanged. Chat is
   never removed: everywhere else on this page, and on every other page of the
   site, the widget behaves exactly as it always has, and if the customer has
   the chat panel OPEN nothing is touched at all.
   Scoped to the creator page. Nothing here touches price, size or the cart.
   ========================================================================== */
(function () {
  if (!document.querySelector('#tnf-creator')) return;          /* creator page only */

  var CONTROLS = '#tnf-logolink, #tnf-proofbtn, #tnf-light, #tnf-pricechip, #tnf-expand, #tnf-nextmode,' +
                 '#tnf-creator input[type="range"], #tnf-creator .tnf-zoom, #tnf-creator [data-zoom],' +
                 '#tnf-creator .tnf-btn, #tnf-creator .tnf-use, #tnf-creator .tnf-chip, #tnf-add';
  var PAD = 6;                       /* a little clearance, so a near miss still steps aside */
  var bubble = null, hidden = false, ticking = false;

  function intersects(a, b) {
    return a.left - PAD < b.right && b.left < a.right + PAD &&
           a.top  - PAD < b.bottom && b.top  < a.bottom + PAD;
  }
  function setHidden(v) {
    if (!bubble || v === hidden) return;
    hidden = v;
    bubble.style.transition = 'opacity .12s linear';
    bubble.style.opacity = v ? '0' : '';
    bubble.style.pointerEvents = v ? 'none' : '';
  }
  var check = function () {
    ticking = false;
    if (!bubble || !bubble.isConnected) return;
    /* an open conversation is never interfered with */
    var host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    if (root && root.querySelector('iframe, .chat-window, [class*="conversation"]')) { setHidden(false); return; }
    var was = bubble.style.opacity;
    bubble.style.opacity = '';                                  /* measure it where it really is */
    var b = bubble.getBoundingClientRect();
    bubble.style.opacity = was;
    if (!b.width) return;
    var clash = false, els = document.querySelectorAll(CONTROLS);
    for (var i = 0; i < els.length && !clash; i++) {
      var r = els[i].getBoundingClientRect();
      if (!r.width || !r.height) continue;
      if (r.bottom < 0 || r.top > window.innerHeight) continue;  /* off screen */
      if (intersects(b, r)) clash = true;
    }
    setHidden(clash);
  }
  function schedule() { if (ticking) return; ticking = true; (window.requestAnimationFrame || setTimeout)(check); }

  /* The Google review badge is the same kind of thing: a floating element that
     is not part of the page, sitting over whatever happens to be under it. It
     is handled by the same rule, so "does a widget cover a control" has one
     answer rather than two. The theme's own sticky bottom bar is NOT touched -
     it is the site's navigation, it behaves the same on every page, and
     removing it here would change the shop rather than fix a widget. */
  /* The badge nests: a full-viewport fixed PositionContainer with
     pointer-events:none, then ActivatePointerEvents - which is the element that
     actually takes the tap - then the visible card inside it. Fading the inner
     card is not enough: its parent still catches the tap. So the outermost node
     with pointer-events:auto is the one managed. Measured 21 Sep 2026:
     PositionContainer 0,0,390,844 (none); ActivatePointerEvents 92,780,207,44 (auto). */
  function reviewBadge() {
    var outer = document.querySelector('[class*="slide-in__PositionContainer"]');
    if (!outer) return null;
    var cands = outer.querySelectorAll('*');
    for (var i = 0; i < cands.length; i++) {
      var cs = getComputedStyle(cands[i]);
      var r = cands[i].getBoundingClientRect();
      if (cs.pointerEvents !== 'none' && r.width > 40 && r.height > 20) return cands[i];
    }
    return null;
  }
  var badge = null;
  function checkBadge() {
    if (!badge || !badge.isConnected) { badge = reviewBadge(); if (!badge) return; }
    var was = badge.style.opacity;
    badge.style.opacity = '';
    var b = badge.getBoundingClientRect();
    badge.style.opacity = was;
    if (!b.width) return;
    var clash = false, els = document.querySelectorAll(CONTROLS);
    for (var i = 0; i < els.length && !clash; i++) {
      var r = els[i].getBoundingClientRect();
      if (!r.width || !r.height || r.bottom < 0 || r.top > window.innerHeight) continue;
      if (intersects(b, r)) clash = true;
    }
    /* the badge is lifted clear of the theme's bottom bar in CSS, which brings
       it near the chat bubble's row. Where the two would touch, the badge is
       the one that gives way - chat has to stay reachable. */
    if (!clash && bubble && bubble.isConnected) {
      var bb = bubble.getBoundingClientRect();
      if (bb.width && getComputedStyle(bubble).opacity !== '0' && intersects(b, bb)) clash = true;
    }
    badge.style.transition = 'opacity .12s linear';
    badge.style.opacity = clash ? '0' : '';
    badge.style.pointerEvents = clash ? 'none' : '';
  }
  var origCheck = check;
  check = function () { origCheck(); try { checkBadge(); } catch (e) {} };
  var badgeTries = 0;
  var badgeTimer = setInterval(function () {
    badgeTries++;
    if (reviewBadge()) { badge = reviewBadge(); checkBadge(); }
    if (badgeTries > 40) clearInterval(badgeTimer);
  }, 400);
  window.addEventListener('scroll', function () { try { checkBadge(); } catch (e) {} }, { passive: true });

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    var host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    var el = root && root.querySelector('.activator-nudge');
    if (el) {
      clearInterval(timer);
      bubble = el;
      check();
      /* The creator builds itself after this runs, and if nobody scrolls, no
         event ever asks again - which is exactly the case that matters, a
         customer landing on the page and reaching straight for Upload. So the
         first ten seconds are re-checked on a timer as the page settles. */
      var settle = 0;
      var settleTimer = setInterval(function () { check(); if (++settle > 20) clearInterval(settleTimer); }, 500);
      window.addEventListener('load', schedule);
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      /* the creator redraws as the design changes, which moves the controls */
      try { new MutationObserver(schedule).observe(document.querySelector('#tnf-creator'), { childList: true, subtree: true, attributes: true }); } catch (e) {}
      try { new MutationObserver(function () {
        var again = root.querySelector('.activator-nudge');
        if (again && again !== bubble) { bubble = again; hidden = false; }
        schedule();
      }).observe(root, { childList: true, subtree: true }); } catch (e) {}
    } else if (tries > 40) {                                    /* ~16 s, then leave it alone */
      clearInterval(timer);
    }
  }, 400);
})();


/* ==========================================================================
   THE CART ARTWORK OPENS A VIEWER, NOT THE PRODUCT PAGE   21 Sep 2026
   A custom sign's cart thumbnail is wrapped in a link to its generated
   product page. Following it takes the customer away from the cart to a page
   of options and a second Add to cart, when all they wanted was a closer look
   at the sheet they just designed. A tap on that thumbnail now opens the
   artwork full size over the cart instead. Nothing navigates, so the cart
   cannot be disturbed.

   WHY NOT THE THEME'S OWN VIEWER. Fancybox 3.5.7 is loaded on the cart and was
   tried first. Measured on the preview at 390x844: it placed the image at
   y 800 in an 844-tall window - bottom-aligned and almost entirely off screen -
   and its pinch zoom could not be made to respond. Rather than fight a
   library's internals from the outside, this is a small viewer whose layout and
   zoom are its own, so every behaviour below is one that can be measured. The
   product page's Fancybox gallery is untouched and still opens there.

   SCOPE. Only an image whose file name is one the order service wrote -
   tnf-<16 hex>.png - is treated this way. A catalogue thumbnail does not match,
   so an ordinary cart line keeps its ordinary link, and the line's TITLE link
   is left alone too, so the product page is still one tap away. The handler is
   delegated from the document, so it survives the re-render after a quantity
   change and would pick up a cart drawer if this theme ever grows one.
   ========================================================================== */
(function () {
  var ART = /\/tnf-[0-9a-f]{16}(_\d+x\d*(@\dx)?)?\.(png|jpe?g|webp)/i;
  var MAX = 6, root = null, imgEl = null, scale = 1, tx = 0, ty = 0, savedScroll = 0, opener = null;

  function isArt(img) { return img && ART.test(img.currentSrc || img.src || ''); }
  /* Shopify serves a sized copy in the cart (..._160x.png); the original is the
     same URL without the size token. The version query is kept, so the file
     shown is the one this line was created with. */
  function fullSize(src) { return String(src).replace(/_\d+x\d*(@\dx)?(?=\.(png|jpe?g|webp))/i, ''); }

  function apply() {
    if (!imgEl) return;
    imgEl.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    root.querySelector('.tnf-v-out').disabled = scale <= 1.01;
  }
  /* keep the sheet on screen: at fit it is centred, zoomed in it may be panned
     only as far as its own edges */
  function clamp() {
    if (!imgEl) return;
    if (scale <= 1) { scale = 1; tx = ty = 0; return; }
    var r = imgEl.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
    var halfW = Math.max(0, (r.width - vw) / 2), halfH = Math.max(0, (r.height - vh) / 2);
    tx = Math.max(-halfW, Math.min(halfW, tx));
    ty = Math.max(-halfH, Math.min(halfH, ty));
  }
  /* zoom about a point, so the thing under the fingers stays under them */
  function zoomTo(next, cx, cy) {
    next = Math.max(1, Math.min(MAX, next));
    var vw = window.innerWidth / 2, vh = window.innerHeight / 2;
    var k = next / scale;
    tx = (tx + vw - cx) * k - vw + cx;
    ty = (ty + vh - cy) * k - vh + cy;
    scale = next;
    clamp(); apply();
  }

  function close() {
    if (!root) return;
    root.remove(); root = null; imgEl = null; scale = 1; tx = ty = 0;
    document.documentElement.classList.remove('tnf-viewer-open');
    document.removeEventListener('keydown', onKey, true);
    var y = savedScroll;                       /* the cart comes back where it was */
    window.scrollTo(0, y);
    requestAnimationFrame(function () { window.scrollTo(0, y); setTimeout(function () { window.scrollTo(0, y); }, 80); });
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) { } }
  }
  function onKey(e) { if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); } }

  function open(img) {
    if (root) return true;
    savedScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    opener = img.closest('a') || img;

    root = document.createElement('div');
    root.className = 'tnf-artwork-viewer';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', (img.alt || 'Your artwork') + ' - full size');
    root.innerHTML =
      '<div class="tnf-v-stage"><img class="tnf-v-img" alt="' + String(img.alt || '').replace(/"/g, '&quot;') + '"></div>' +
      '<button type="button" class="tnf-v-close" aria-label="Close">&times;</button>' +
      '<div class="tnf-v-zoom">' +
        '<button type="button" class="tnf-v-out" aria-label="Zoom out">&minus;</button>' +
        '<button type="button" class="tnf-v-in" aria-label="Zoom in">+</button>' +
      '</div>' +
      '<p class="tnf-v-hint"></p>';
    document.body.appendChild(root);
    document.documentElement.classList.add('tnf-viewer-open');

    imgEl = root.querySelector('.tnf-v-img');
    imgEl.src = fullSize(img.currentSrc || img.src);
    root.querySelector('.tnf-v-hint').textContent =
      (img.alt || '').trim() + (('ontouchstart' in window) ? ' — pinch or double-tap to zoom' : ' — scroll or use + / − to zoom');

    root.querySelector('.tnf-v-close').addEventListener('click', close);
    root.querySelector('.tnf-v-in').addEventListener('click', function () { zoomTo(scale * 1.6, innerWidth / 2, innerHeight / 2); });
    root.querySelector('.tnf-v-out').addEventListener('click', function () { zoomTo(scale / 1.6, innerWidth / 2, innerHeight / 2); });
    /* a tap on the dark surround closes; a tap on the sheet does not */
    root.addEventListener('click', function (e) { if (e.target === root || e.target.classList.contains('tnf-v-stage')) close(); });
    document.addEventListener('keydown', onKey, true);

    /* ---- touch: pinch to zoom, drag to pan, double-tap to toggle ---- */
    var pinchFrom = 0, scaleFrom = 1, lastX = 0, lastY = 0, panning = false, lastTap = 0;
    var dist = function (t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.hypot(dx, dy); };
    var mid = function (t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; };

    root.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) { pinchFrom = dist(e.touches); scaleFrom = scale; panning = false; e.preventDefault(); }
      else if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lastTap < 320) { zoomTo(scale > 1.05 ? 1 : 3, e.touches[0].clientX, e.touches[0].clientY); lastTap = 0; e.preventDefault(); return; }
        lastTap = now;
        panning = scale > 1.01; lastX = e.touches[0].clientX; lastY = e.touches[0].clientY;
      }
    }, { passive: false });

    root.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinchFrom) {
        var m = mid(e.touches);
        zoomTo(scaleFrom * (dist(e.touches) / pinchFrom), m.x, m.y);
        e.preventDefault();
      } else if (panning && e.touches.length === 1) {
        tx += e.touches[0].clientX - lastX; ty += e.touches[0].clientY - lastY;
        lastX = e.touches[0].clientX; lastY = e.touches[0].clientY;
        clamp(); apply(); e.preventDefault();
      }
    }, { passive: false });

    root.addEventListener('touchend', function (e) { if (e.touches.length < 2) pinchFrom = 0; if (!e.touches.length) panning = false; }, { passive: true });

    /* ---- desktop: wheel to zoom, drag to pan, double-click to toggle ---- */
    root.addEventListener('wheel', function (e) { e.preventDefault(); zoomTo(scale * (e.deltaY < 0 ? 1.18 : 1 / 1.18), e.clientX, e.clientY); }, { passive: false });
    root.addEventListener('dblclick', function (e) { zoomTo(scale > 1.05 ? 1 : 3, e.clientX, e.clientY); });
    root.addEventListener('mousedown', function (e) { if (scale <= 1.01) return; panning = true; lastX = e.clientX; lastY = e.clientY; e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { if (!panning || !root) return; tx += e.clientX - lastX; ty += e.clientY - lastY; lastX = e.clientX; lastY = e.clientY; clamp(); apply(); });
    window.addEventListener('mouseup', function () { panning = false; });

    apply();
    setTimeout(function () { var c = root && root.querySelector('.tnf-v-close'); if (c) try { c.focus({ preventScroll: true }); } catch (e) { } }, 60);
    return true;
  }

  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;   /* open in a new tab still works */
    /* the proof page marks its own sheet: no link to follow, just open it */
    var marked = e.target.closest && e.target.closest('[data-tnf-artwork]');
    if (marked) {
      var mi = marked.tagName === 'IMG' ? marked : marked.querySelector('img');
      if (isArt(mi)) { e.preventDefault(); e.stopPropagation(); open(mi); return; }
    }
    var link = e.target.closest && e.target.closest('a');
    if (!link) return;
    var img = link.querySelector && link.querySelector('img');
    if (!isArt(img)) return;                       /* catalogue lines keep their link */
    e.preventDefault(); e.stopPropagation();
    open(img);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || root) return;
    var link = document.activeElement && document.activeElement.closest && document.activeElement.closest('a');
    var img = link && link.querySelector && link.querySelector('img');
    if (isArt(img)) { e.preventDefault(); open(img); }
  });
})();
